import { useQuery } from '@tanstack/react-query';

import { postData } from 'src/app/queries';

import type { QueryKey } from '@tanstack/react-query';

export const lspLocationsQueryKey: QueryKey = ['lsp-locations'];

type LspLocationsBackendResponse = {
  City: string;
  HasPermission: boolean;
  IsBioTrackIntegrated: boolean;
  IsLive: boolean | null;
  LicenseTypeIds: Record<string, number>[];
  LocId: number;
  Logo: string | null;
  MDCompanyFlag: string;
  Name: string;
  RegistersAvailable: number;
  State: string;
  WhichUnitCost: string;
  WhichUnitPrice: string;
};

export function useLspLocationsQuery() {
  return useQuery({
    queryKey: lspLocationsQueryKey,
    queryFn: () =>
      postData<null, LspLocationsBackendResponse[]>({
        payload: null,
        endpoint: 'api/posv3/maintenance/GetLspLocationsBackend',
      }),
  });
}
